import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import React, { Fragment, useMemo } from 'react'

import EmptyState from '@/components/EmptyState'
import RegulationCard from '@/modules/investment/components/RegulationCard'
import { getDetailRegulationList } from '@/services/sez-regions'
import { ListBasicRequest } from '@/types/sez-regions'
import { useAppSelector } from '@/utils/hooks'

const Regulation: React.FC = () => {
  const router = useRouter()
  const { t } = useTranslation()

  const request: ListBasicRequest = useMemo(() => {
    return {
      params: { slug: String(router.query?.slug), skip: 0, limit: 1000 },
      headers: { 'Accept-Language': String(router.locale) },
    }
  }, [])

  const { data: dataRegulation } = useAppSelector(getDetailRegulationList.select(request))

  return (
    <div className='container flex w-full flex-col gap-4 lg:gap-8'>
      <div className='flex flex-col gap-4'>
        {dataRegulation && dataRegulation.data.items.length > 0 ? (
          <>
            {dataRegulation?.data.items.map((item) => (
              <Fragment key={item.xid}>
                <h5 className='font-bold text-gray-1'>{item.title}</h5>
                {item.regulations.map((regulation) => (
                  <RegulationCard
                    key={item.xid}
                    regulation={regulation}
                  />
                ))}
              </Fragment>
            ))}
          </>
        ) : (
          <EmptyState
            title={String(t('common:emptyState.title'))}
            description={String(t('common:emptyState.description'))}
            contentWidth='lg:w-full'
          />
        )}
      </div>
    </div>
  )
}

export default Regulation
